import * as React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'antd';

import s from './GroupInfo.pcss';
import GroupEditor from '../../GroupList/GroupEditor';
import GroupUsersModal from './GroupUsersModal';
import GroupUnitsModal from './GroupUnitsModal';


export default class GroupInfo extends React.Component {
  static propTypes = {
    data: PropTypes.shape().isRequired,
    onEdit: PropTypes.func.isRequired,
  };

  state = {
    mode: '',
  };

  setMode = mode => this.setState({ mode });

  editGroup = (id, name) => {
    const data = { id, name };
    this.props.onEdit(data)
      .then(() => {
        this.setState({ mode: '' });
      });
  };

  render() {
    const { data } = this.props;
    const { mode } = this.state;
    return (
      <div className={s.container}>
        <div className={s.info}>
          <div className={s.email}>{data.name}</div>
          <div className={s.controls}>
            <Button type="primary" className={s.editBtn} onClick={() => this.setMode('edit')}>
              Редактировать
            </Button>
            <Button className={s.editBtn} onClick={() => this.setMode('users')}>
              Пользователи
            </Button>
            <Button className={s.editBtn} onClick={() => this.setMode('units')}>
              Подразделения
            </Button>
            <GroupEditor
              group={data}
              visible={mode === 'edit'}
              onClose={() => this.setMode(false)}
              onEdit={this.editGroup}
            />
            <GroupUsersModal
              group={data}
              visible={mode === 'users'}
              onClose={() => this.setMode(false)}
            />
            <GroupUnitsModal
              group={data}
              visible={mode === 'units'}
              onClose={() => this.setMode(false)}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Groups/GroupPage/GroupInfo/GroupInfo.js